import { CSSProperties, useContext } from 'react'
import { IconDownload } from '../img'
import { DataContext } from '../data/DataContext';
import { homePageLAFISE } from '../data/MochaData'

const StepFinish = () => {
    const { AutoEmisionCR } = useContext(DataContext);

    const style: CSSProperties = {
        display: 'flex',
        justifyContent: 'center'
    }

    const Download = (e: any) => {
        e.preventDefault();
        AutoEmisionCR.downloadPolicy(AutoEmisionCR.idPol.toString());
    }

    const Finalizar = (e: any) => {
        e.preventDefault();
        if (window.top !== null && window.top !== undefined)
            window.top.location.href = homePageLAFISE;
    }

    return (
        <>
            <label style={{ ...style, textAlign: 'center', fontSize: '20px', color: '#008866', lineHeight: '30px' }}>¡Gracias por confiar en <br></br> seguro LAFISE!</label>
            <div style={style} className='mt-30 mb-30'>
                <IconDownload />
            </div>

            <p style={{ ...style, textAlign: 'center', fontSize: '15px', color: '#4D4D4D', lineHeight: '22px' }}>
                Le estamos enviando su póliza al <br /> correo descrito anteriormente, <br /> disfrute de la posibilidad de <br /> tener su seguro al instante <br /> descargándolo  dando click <br />
                al botón

            </p>
            <div style={style} className='mt-30 mb-30'>
                <button className='btn-auto-cr back-auto-cr' onClick={Download} type="button">Descargar póliza</button>
            </div>

            <div style={style} className='mt-20 mb-30'>
                <button className='btn-auto-cr next-auto-cr' onClick={Finalizar} >Finalizar</button>
            </div>

        </>

    )
}

export { StepFinish }